import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'idToLocation',
})
export class IdToLocationPipe implements PipeTransform {
  transform(value: unknown, outlets: any): string {
    if (value && outlets && outlets.length) {
      let outlet = outlets.find((o: any) => o.id == value);
      return outlet && outlet.name ? outlet.name : 'unknown outlet';
    } else {
      return 'unknown outlet';
    }
  }
}
